import {Directive, ElementRef, Renderer2} from "@angular/core";
import {environment} from "../../environments/environment";

@Directive({
  selector: '[content-outlink]'
})
export class ContentOutlinkDirective {

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit() {
    if(environment.app) {
      let links = this.elementRef.nativeElement.getElementsByTagName('a');
      for (let i = 0; i < links.length; i++) {
        this.renderer.listen(links[i], 'click', function (event) {
          event.preventDefault();
          cordova.InAppBrowser.open(event.target.href, '_blank', '');
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/directive/content-outlink.directive.ts